<template>
  <div class="search-content">
    <template v-for="(item,index) in searchList">
      <SearchInput :ref="item.column" v-if="item.searchType == 0" :searchLabel="item.searchLabel" :searchWidth="item.searchWidth"></SearchInput>
      <SearchSelect :ref="item.column" v-if="item.searchType == 1" :searchLabel="item.searchLabel" :searchWidth="item.searchWidth"
        :searchTermList="item.searchTermList"></SearchSelect>
      <SearchRadio :ref="item.column" v-if="item.searchType == 2" :searchLabel="item.searchLabel" :searchWidth="item.searchWidth"
        :searchTermList="item.searchTermList"></SearchRadio>
      <SearchCheckbox :ref="item.column" v-if="item.searchType == 3" :searchLabel="item.searchLabel" :searchWidth="item.searchWidth"
        :searchValue="item.searchValue" :searchTermList="item.searchTermList"></SearchCheckbox>
      <SearchDate :ref="item.column" v-if="item.searchType == 4" :searchLabel="item.searchLabel" :searchWidth="item.searchWidth"
        :searchValue="item.searchValue" :searchDateType="item.searchDateType"></SearchDate>
				<searchAutocomplete :ref="item.column" v-if="item.searchType == 5" :searchLabel="item.searchLabel" :searchWidth="item.searchWidth"
				  :searchTermList="item.searchTermList"></searchAutocomplete>
      <div v-if="item.searchBr" style="width: 100%;"></div>
    </template>
  </div>
</template>
<script>
  import SearchCheckbox from "@/components/list/search/searchCheckbox";
  import SearchInput from "@/components/list/search/searchInput";
  import SearchRadio from "@/components/list/search/searchRadio";
  import SearchSelect from "@/components/list/search/searchSelect";
  import SearchDate from "@/components/list/search/searchDate";
  import searchAutocomplete from "@/components/list/search/searchAutocomplete";
  export default {
    name: 'searchList',
    components: {
      SearchCheckbox,
      SearchInput,
      SearchRadio,
      SearchSelect,
      SearchDate,
	  searchAutocomplete
    },
    props: {
      searchList: {
        type: Array,
        default: []
      },
    },
    data: function() {
      return {
        searchParam: {}
      }
    },
    methods: {
      getSearchParam() {
        var $this = this;
        var searchParam = {};
        this.searchList.forEach(function(item, index) {
          var param = $this.$refs[item.column][0];
          if ((param.value != null && param.value != undefined && param.value != '') || param.value === 0) {
            searchParam[item.column] = param.value;
          }
        })
        return searchParam;
      },
    }
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/list/searchList.vue